import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
    scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      console.log('chamou')
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }
  },
});

export default router;
